<template>
  <footer
    class="sidearm-mm-main-footer bg-size-cover text-white"
    data-anchor=""
  >
    <div class="sidearm-mm-main-footer__top-container py-2">
      <div class="col-6-of-8 col-push-1">
        <div class="text-center">
          <!-- <ad name="tournament-experience-cs-main-footer-1" :sport-id="$root.sport_id" /> -->
          <!-- <img src="https://dummyimage.com/320x50/1C453B/ffffff" alt="" /> -->
        </div>

        <div
          class="sidearm-mm-main-footer__top-content flex flex-column large-flex-row flex-align-center flex-justify-center large-flex-justify-between"
        >
          <div class="flex flex-column medium-flex-column flex-align-center">
            <div
              v-if="
                this.$root.final_four_location.name &&
                  this.$root.final_four_location.abbrev
              "
              class="sidearm-mm-main-footer__tag flex flex-column medium-flex-column flex-align-center text-bold"
            >
              <span class="mr-2">The Road To</span>
              <abbr :title="this.$root.final_four_location.name">{{
                this.$root.final_four_location.abbrev
              }}</abbr>
            </div>
            <div class="sidearm-mm-main-footer__sponsor ma-2">
              <ad
                name="tournament-experience-footer-1"
                :sport-id="$root.sport_id"
              />
            </div>
          </div>

          <a href="https://sidearmsports.com" target="_blank" class="my-2">
            <img
              src="~@/assets/sidearm_logo.svg"
              alt="SIDEARM Sports Logo"
              class="sidearm-mm-main-footer__sidearm-logo"
            />
          </a>
        </div>
      </div>
    </div>

    <div
      class="sidearm-mm-main-footer__continue-container bg-primary text-on-primary py-3"
    >
      <div
        class="sidearm-mm-main-footer__continue-container-inside col-8-of-8 large-col-6-of-8 large-col-push-1 flex flex-align-center flex-justify-center large-flex-justify-start"
      >
        <a
          :href="`${$root.continue_url}`"
          class="sidearm-mm-main-footer__continue-link flex inline-flex flex-align-center text-decoration-none text-on-primary text-bold"
        >
          <span>
            <span class="hide-on-small-down">Continue to </span>
            {{ site_url }}</span
          >
          <img
            :src="$root.school_logo(48, 48)"
            :alt="
              $root.data.school.name ? $root.data.school.name : 'School Logo'
            "
            class="mx-2"
          />
          <icon size="1.625rem">sf-arrows-long-right</icon>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data: () => ({
    site_url: window.location.host
  })
};
</script>

<style lang="scss" scoped>
.#{$prefix}-main-footer {
  background: $color-black url("~@/assets/section_footer_bg.png") no-repeat top
    center;

  &__top-content {
    padding: grid_percent(200) 0;
  }

  &__tag {
    abbr {
      -webkit-text-stroke: 1px $color-white;
      color: rgba($color-white, 0);
      font-family: $font-abolition;
      font-size: 64px;
      font-weight: 400;
      text-decoration: none;
    }
  }

  &__sidearm-logo {
    max-width: 168px;
  }

  &__continue-container-inside {
    &::before {
      @include flex-item(1 1 0px);

      border-top: 1px dashed $text-on-primary;
      content: "";
      display: block;
      height: 1px;
      margin-right: grid_percent(120);
    }
  }
  &__continue-link {
    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: #{$breakpoint-large}) {
    &__continue-container-inside {
      &::before {
        display: none;
      }
    }
  }
}
</style>
